module.exports = __webpack_public_path__ + "files/301132c0689e5946e55dedb6d4c451ab.svg";